import { createActionName } from './naming';
import * as types from './actionsTypes';

export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SEND_FORM),
  payload
});

export const setFieldSum = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_SUM),
  payload
});

export const setFieldPaymentSystem = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_PAYMENT_SYSTEM),
  payload
});

export const setResultObject = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_RESULT_OBJECT),
  payload
});

export const initState = reducerName => ({
  type: createActionName(reducerName, types.INIT_STATE)
});



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/actions.js